/**
 * Reads the AIChatConversation ACTIONS context. Throws if used outside its provider.
 *
 * Actions-only read path for the Conversation slice (setCurrentConversationId /
 * setStreamStatus / queueMessage / pill setters / …). Consumers that only dispatch should
 * prefer this hook over useAIChatConversation() so they subscribe to the stable action object
 * and never re-render on Conversation state changes.
 */
import { useContext } from 'react';
import { AIChatConversationActionsContext } from './AIChatConversationProvider';
import type { AIChatConversationActions } from './AIChatConversationProvider';

export function useAIChatConversationActions(): AIChatConversationActions {
  const context = useContext(AIChatConversationActionsContext);
  if (!context) {
    throw new Error('useAIChatConversationActions must be used within a AIChatConversationProvider');
  }
  return context;
}
